<template>
  <div class="loan-record-container">
    <van-nav-bar
      :title="locale == 'zh' ? '貸款記錄' : 'Loan Record'"
      left-text="返回"
      left-arrow
    >
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
    </van-nav-bar>
    <div class="content">
      <van-tabs v-model="active" color="#0062f8" @click="tabClick">
        <van-tab :title="locale == 'zh' ? '全部' : 'All'"></van-tab>
        <van-tab :title="locale == 'zh' ? '申請中' : 'Applying'"></van-tab>
        <van-tab :title="locale == 'zh' ? '成功' : 'Successful'"></van-tab>
        <van-tab :title="locale == 'zh' ? '失敗' : 'Failed'"></van-tab>
      </van-tabs>
      <van-empty description="no data" v-if="loanList.length == 0" />
      <div class="record-list" v-if="loanList.length > 0">
        <div
          class="record-list-item"
          @click="goDetail(index)"
          v-for="(item, index) in loanList"
          :key="item.id"
        >
          <div class="record-list-item-left">
            <div class="left-top">{{ item.amount }} USDT</div>
            <div class="left-bot">
              {{ (item.created_at * 1000) | dateFormat("dd-MM-yyyy") }}
            </div>
          </div>
          <div class="record-list-item-right">
            <span v-if="item.status == 2">{{
              locale == "zh" ? "貸款成功" : "Successful"
            }}</span>
            <span v-if="item.status == 3">{{
              locale == "zh" ? "貸款失敗" : "Failed"
            }}</span>
            <span v-if="item.status == 1">{{
              locale == "zh" ? "申請中" : "Applying"
            }}</span>
            <img src="../../assets/arrow-right.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      loanList: [],
      page: 1,
      lastPage: 1,
      locale: "en",
    };
  },
  created() {
    if (this.I18n.locale.indexOf("zh") != -1) {
      this.locale = "zh";
    }
    this.getLoanList();
  },
  mounted() {
    window.addEventListener("scroll", this.scroll);
  },
  methods: {
    async scroll() {
      let scroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      if (this.page < this.lastPage) {
        if (scrollHeight - scroll <= 850) {
          this.page++;
          this.getLoanList();
        }
      }
    },
    tabClick(e) {
      this.active = e;
      this.page = 1;
      this.getLoanList();
    },
    goDetail(index) {
      if (this.loanList[index].status == 2) {
        this.$router.push({
          path: "/loan-record-detail",
          query: {
            id: this.loanList[index].id,
          },
        });
      }
      if (this.loanList[index].status == 1) {
        this.$Dialog.alert({
          message: "Applying",
          confirmButtonText: "confirm",
        });
      }
      if (this.loanList[index].status == 3) {
        this.$Dialog.alert({
          message: this.loanList[index].message,
          confirmButtonText: "confirm",
        });
      }
    },
    async getLoanList() {
      const res = await this.$api.getLoanList({
        page: this.page,
        status: this.active ? this.active : "",
      });
      if (res.code == 200) {
        this.lastPage = res.data.last_page;
        if (this.page == 1) {
          this.loanList = res.data.data;
        } else {
          this.loanList.push(...res.data.data);
        }
      }
    },
    navBack() {
      this.$router.replace("/loan");
    },
  },
};
</script>

<style lang="scss" scoped>
.loan-record-container {
  .back {
    width: 30px;
    height: 15px;
  }
  .content {
    .record-list {
      background: #fff;
      padding: 0 15px;
      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        background: #fff;
        border-bottom: 1px solid #ddd;
        &-left {
          .left-top {
          }
          .left-bot {
            font-size: 14px;
            color: #999;
            margin-top: 5px;
          }
        }
        &-right {
          display: flex;
          align-items: center;
          color: #999;
          img {
            width: 15px;
            height: 15px;
          }
        }
      }
    }
  }
}
</style>